import React from 'react';

import PropTypes from 'prop-types';

const Icon = ({
  children,
  className = '',
  style = {},
  viewBox = '0 0 32 32',
  width = 30,
  height = 30,
}: any) => (
  <svg
    className={className}
    width={width}
    height={height}
    style={style}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
  >
    {children}
  </svg>
);

Icon.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]).isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  viewBox: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Icon;
